import gql from 'graphql-tag';

const DAILY_BRIEF_FRAGMENT = gql`
	fragment serviceRunDailyBrief on ServiceRun {
		id
		planned
		order
		brief
		briefAcknowledgedAt
		machineCount
		vehicleConfirmed
		warehouse {
			id
			name
		}
		vehicle {
			id
			name
		}
		route {
			id
			name
		}
		driver {
			id
			username
			firstname
			lastname
			destroyed
		}
		serviceDockets {
			id
			status
			date
			startedProcessing
			markedCompleteAt
			isRestocked
			manualRestock
			manualRestockComment
			manualRestockApprovedBy {
				id
				firstname
				lastname
			}
			inventoryCheck
			replacementReviewRequired
			replacementReviewReason
			inventoryPicked
			inventoryPartiallyPicked
			inventoryChanges
			inventoryChangesPercentage
			inventoryChangesSelections
			ticketsResolved
			someTicketsNotResolved
			driverTicketCount
			collectCash
			cashCollected
			requirePhoto
			photoTaken
			permanentPackTags {
				id
				name
				abbreviation
			}
			packTags {
				id
				name
				abbreviation
			}
			machineServiceType
			machineRestockType
			vendsSinceLastRestock
			order
			pickList {
				id
				isAnyItemPicked
			}
			serviceRun {
				id
			}
			place {
				id
				name
				destroyed
			}
			location {
				id
				name
				noteCount
				destroyed
			}
			machine {
				id
				type
				assetId
				destroyed
				noteCount
				vendouts
				vendsSinceLastRestock
				openTicketCount
				openIssueTicketCount
				openMaintenanceTicketCount
				openJobTicketCount
				isOffline
				usesIngredients
				planogram {
					id
				}
				place {
					id
					name
					destroyed
				}
				location {
					id
					name
					noteCount
					destroyed
				}
			}
		}
	}
`;

export default DAILY_BRIEF_FRAGMENT;
